import React from 'react';
import { RiArrowLeftFill } from "@remixicon/react";
import { Link, useNavigate } from "react-router-dom";
const BackHome = () => {
  const navigate = useNavigate();

  return (
    <div className="absolute top-8 left-24">
      <button className="bg-gray-800 rounded-md p-4" title='Back to Home' onClick={() => navigate('/')}>
        <RiArrowLeftFill className="text-white-500" />
      </button>
    </div>
  );
};

export default BackHome;


